<template>
	<div>
		<div class="main">
			<div v-if="!isLoading">
				<div class="w-full flex justify-start">
					<div class="flex flex-col w-full">
						<video controls v-if="videoUrl" :src="videoUrl" style="max-height: 800px"></video>
						<div v-else>
							{{ $t('video_cannot_be_played') }}
						</div>
					</div>
				</div>
			</div>
			<LoadingSpinner class="pt-2" v-else />
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import DashboardRepository from '@/api/repositories/DashboardRepository';

export default {
	name: 'DashboardVideoModal',
	components: { LoadingSpinner },
	mixins: [Validate, Authentication],
	data() {
		return {
			isLoading: true,
			videoUrl: null,
		};
	},
	methods: {
		async loadVideo() {
			try {
				const { data: blob } = await new DashboardRepository().getVideoById(this.$route.params.videoId);
				this.videoUrl = URL.createObjectURL(blob);
			} catch (e) {
				this.$swal(this.$t('general.error'), this.$t('video_cannot_be_played'), 'error').then(() => this.$router.go(-1));
			} finally {
				this.isLoading = false;
			}
		},
	},
	mounted() {
		this.isLoading = true;
		this.loadVideo();
	},
};
</script>

<style scoped></style>
